import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OpsState {
  token: string | null;
  setToken: (token: string) => void;
  clear: () => void;
}

export const useOpsStore = create<OpsState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      clear: () => set({ token: null }),
    }),
    { name: "oneshift-ops" },
  ),
);
